import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class CreditorDeptPaymentPopUp extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      employees: [],
      accounts: [],
    },
    data: {
      amount: "",
      account_id: "",
      payment_date: "",
      remark: "",
      attachment: "",
      paid_by_staff_id: "",
      bank_ref_no: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const { popUp } = this.context;

    console.log(popUp);

    if (popUp?.edit) {
      data.amount = popUp.edit.amount;
      data.account_id = popUp.edit.account_id;
      data.payment_date = popUp.edit.payment_date;
      data.paid_by_staff_id = popUp.edit.paid_by_staff_id;
      data.remark = popUp.edit.remark;
      data.bank_ref_no = popUp.edit.bank_ref_no;
    }

    await db
      .getAll(`dropdowns/staff?sectionId=1`)
      .then(({ data: { data } }) => (drp["employees"] = data));

    await db
      .getAll(`dropdowns/accounts`)
      .then(({ data: { data } }) => (drp["accounts"] = data));

    this.setState({ drp, data });
  };

  schema = {
    amount: Joi.number().required(),
    account_id: Joi.number().required(),
    paid_by_staff_id: Joi.number().required(),
    payment_date: Joi.date().required(),
    remark: Joi.string().required(),
    attachment: Joi.allow(null).allow(""),
    bank_ref_no: Joi.string().required(),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        creditor_id: popUp.cache ? popUp.cache : popUp.edit.creditor_id,
        ...this.state.data,
      });

      await db
        .form("creditors/payment", target, __controls, popUp?.edit?.id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })
        .catch((e) => {
          togglePopUp({
            form: "toast",
            message: e.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.PaymentEdit : lbl.Payment}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderSelect("account_id", "حساب", drp["accounts"])}
            {this.renderSelect("paid_by_staff_id", "توسط", drp["employees"])}
            {this.renderInput("payment_date", "تاریخ پرداخت", "date")}
            {this.renderInput("bank_ref_no", "ریفرنس نمبر")}
            {this.renderInput("remark", "ملاحظه", "textarea")}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default CreditorDeptPaymentPopUp;
